import { combineReducers } from 'redux';
import { IPermissions } from '../../models/auth';
import { default as auth, IAuthState } from './auth';
import commissary, { ICommissaryState } from './commissary';
import { default as common, ICommonState } from './common';
import controlCenter, { IControlCenterState } from './control-center';
import facility, { IFacilityState } from './facility';
import profile, { IProfileState } from './profile';
import { default as siteMessage, ISiteMessageState } from './site-message';
import users, { IUsersState } from './users';

export interface IAppState {
  auth: IAuthState;
  common: ICommonState;
  facility: IFacilityState;
  siteMessage: ISiteMessageState;
  users: IUsersState;
  commissary: ICommissaryState;
  profile: IProfileState;
  controlCenter: IControlCenterState;
  permissions: IPermissions;
}

export default combineReducers({
  auth,
  common,
  facility,
  siteMessage,
  users,
  commissary,
  profile,
  controlCenter
});
